const ThirdPartyService = require('third-party/third-party-service.js');

const IntercomScript = (function(root, doc, undefined) {

    'use strict';

    const isVendorDisabled = () => {
        return ThirdPartyService.isVendorDisabled();
    };

    /**
     * Loads Intercom SDK
     */
    const load = (APP_ID) => {

        if(isVendorDisabled()){
            return false;
        }

        /**
         * Intercom works like GTM,
         * Script is loaded after the load
         * and there is a 'queue' logic behind the scene
         * It means Intercom methods can be triggered immediately
         * and will be fired as soon as Intercom will be ready.
         */
        (function() {

            var w = window;
            var ic = w.Intercom;

            if (typeof ic === 'function') {
                ic('reattach_activator');
                ic('update', w.intercomSettings);
            } else {
                var d = document;
                var i = function() {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function(args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                var l = function() {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://widget.intercom.io/widget/' + APP_ID;
                    var x = d.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                };
                l();
            }

        })();

    };

    return {
        load
    };

})(window, document);

module.exports = IntercomScript;
